import { ObjectMapper } from 'json-object-mapper';
import { Model } from 'services/models/model';
import { IModel } from 'services/models/IModel';

/** Resposta de campo de admissão digital ligada ao candidato (pré-cadastro). */
export class RecruitmentAdmissionCustomFieldAnswerModel
  extends Model
  implements IModel<RecruitmentAdmissionCustomFieldAnswerModel>
{
  public recruitmentCandidateId: string = '';
  public admissionCustomFieldItemId: string = '';
  public value: string = '';
  public valueFileName: string = '';

  static create(input: any): RecruitmentAdmissionCustomFieldAnswerModel {
    const source = input || {};
    const normalized = {
      ...source,
      id: source.id ?? source.Id ?? '',
      recruitmentCandidateId: source.recruitmentCandidateId ?? source.RecruitmentCandidateId ?? '',
      admissionCustomFieldItemId:
        source.admissionCustomFieldItemId ?? source.AdmissionCustomFieldItemId ?? '',
      value: source.value ?? source.Value ?? '',
      valueFileName: source.valueFileName ?? source.ValueFileName ?? '',
    };
    const answer = ObjectMapper.deserialize<RecruitmentAdmissionCustomFieldAnswerModel>(
      RecruitmentAdmissionCustomFieldAnswerModel,
      normalized
    );

    answer.id = String(normalized.id || answer.id || '');
    answer.recruitmentCandidateId = String(normalized.recruitmentCandidateId || '');
    answer.admissionCustomFieldItemId = String(normalized.admissionCustomFieldItemId || '');
    answer.value = String(normalized.value ?? '');
    answer.valueFileName = String(normalized.valueFileName ?? '');
    return answer;
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
